import styled from 'styled-components';
import { Button as AntButton, Input } from 'antd';
import { Box, CustomInput, Text, Button } from 'atoms';
import { FilterAtnButton } from 'utils/commonStyled';

// Layout Styled Components
export const PageContainer = styled(Box)`
	padding: 24px;
`;

export const HeaderContainer = styled(Box)`
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 24px;
`;

export const HeaderRightSection = styled(Box)`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-left: auto;
`;

export const Title = styled.h1`
	font-size: 24px;
	font-weight: 600;
	margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
	font-size: 14px;
	color: #666;
	margin: 0;
`;

// Steps Styled Components
export const StepsContainer = styled(Box)`
	background: #ffffff;
	padding: 32px 80px;
	border-radius: 8px;
	margin-bottom: 24px;
`;

export const CustomSteps = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export const StepItem = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
`;

export const StepCircle = styled(Box)`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 600;
	color: ${(props) => (props.active || props.completed ? '#fff' : '#999')};
	background: ${(props) => (props.active || props.completed ? '#1890ff' : '#fff')};
	border: 2px solid ${(props) => (props.active || props.completed ? '#1890ff' : '#d9d9d9')};
	z-index: 1;
`;

export const StepLabel = styled(Text)`
	margin-top: 8px;
	font-size: 14px;
	font-weight: ${(props) => (props.active ? '600' : '400')};
	color: ${(props) => (props.active ? '#18405d' : '#999')};
`;

export const StepConnector = styled(Box)`
	width: 200px;
	height: 2px;
	background: ${(props) => (props.completed ? '#1890ff' : '#d9d9d9')};
	margin: 0 16px;
	margin-bottom: 30px;
`;

// Form Styled Components
export const FormContainer = styled(Box)`
	background: #fff;
	padding: 24px;
	border-radius: 8px;
`;

export const SectionTitle = styled.h2`
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 24px;
`;

export const BillingAddressBox = styled(Box)`
	background: #fff;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 16px;
`;

export const FileItem = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4px 12px;
	background: #f5f5f5;
	border-radius: 4px;
	gap: 12px;
	max-width: 400px;
`;

// Input Styled Components
export const DisabledInput = styled(CustomInput)`
	background-color: #dfdfdf !important;
	color: #000 !important;

	input {
		background-color: #dfdfdf !important;
		color: #000 !important;
	}
`;

export const DocumentTypeInput = styled(CustomInput)`
	background-color: #c6c6c8 !important;
	color: #fff !important;

	input {
		background-color: #18405d !important;
		color: #fff !important;
	}
`;

// Button Styled Components
export const AddButton = styled(AntButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	border: 1px solid #18405d;
	color: #18405d;
	background: #fff;
	height: 40px;
	padding: 0 16px;

	&:hover {
		border-color: #18405d;
		color: #18405d;
	}
`;

export const AddDocumentButton = styled(AntButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	border: 1px solid #18405d;
	color: #18405d;
	background: #fff;
	height: 40px;
	padding: 0 16px;

	&:hover:not(:disabled) {
		background: #1a4a6e !important;
		color: #fff !important;
	}

	&:focus:not(:disabled) {
		background: #18405d !important;
		color: #fff !important;
	}

	&:disabled {
		background: #f5f5f5;
		color: #999;
		border-color: #d9d9d9;
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const BrowseButton = styled(FilterAtnButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 180px;
`;

export const CRFBrowseButton = styled(FilterAtnButton)`
	display: flex;
	align-items: center;
	gap: 0px;
	min-width: 640px;
	width: auto;
`;

export const NextButton = styled(FilterAtnButton)`
	min-width: 120px;
`;

export const PreviousButton = styled(Button)`
	min-width: 120px;
	border: 1px solid #18405d;
	color: #18405d;
	background: #fff;
`;

export const SaveButton = styled(FilterAtnButton)`
	min-width: 140px;
`;

export const CancelButton = styled(AntButton)`
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	color: #ff4d4f;
	border: 1px solid #ff4d4f;
	height: 40px;
	min-width: 120px;
	font-weight: 500;

	&:hover {
		background: #fff1f0;
		color: #ff4d4f;
		border-color: #ff4d4f;
	}
`;

export const BlackListButton = styled(AntButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	background: #fff;
	color: #ff4d4f;
	border: 1px solid #ff4d4f;
	height: 40px;
	padding: 0 20px;
	font-weight: 500;

	&:hover:not(:disabled) {
		background: #fff1f0;
		color: #ff4d4f;
		border-color: #ff4d4f;
	}

	&:disabled {
		background: #f5f5f5;
		color: #999;
		border-color: #d9d9d9;
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const EditButton = styled(AntButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	background: #18405d;
	color: #fff;
	border: none;
	height: 40px;
	padding: 0 20px;
	font-weight: 500;

	&:hover {
		background: #1a4a6e;
		color: #fff;
	}
`;

export const VerifyButton = styled(AntButton)`
	display: flex;
	align-items: center;
	gap: 8px;
	border: 1px solid #52c41a;
	color: ${(props) => (props.verified ? '#fff' : '#52c41a')};
	background: ${(props) => (props.verified ? '#52c41a' : 'transparent')};
	height: 40px;
	padding: 0 20px;
	font-weight: 500;

	&:hover {
		background: ${(props) => (props.verified ? '#52c41a' : '#73d13d')};
		color: #fff;
		border-color: ${(props) => (props.verified ? '#52c41a' : '#73d13d')};
	}

	&:disabled {
		background: #52c41a;
		color: #fff;
		border-color: #52c41a;
		opacity: 1;
		cursor: not-allowed;
	}
`;

// Modal Styled Components
export const BlacklistModalContent = styled(Box)`
	padding: 8px 0;
	justify-content: center;
`;

export const BlacklistModalTitle = styled.h3`
	font-size: 20px;
	font-weight: 600;
	color: #000;
	margin: 0 0 12px 0;
`;

export const BlacklistModalDescription = styled.p`
	font-size: 14px;
	color: #666;
	margin: 0 0 20px 0;
	line-height: 1.5;
`;

export const BlacklistReasonLabel = styled.label`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #000;
	margin-bottom: 8px;
`;

export const BlacklistReasonInput = styled(Input.TextArea)`
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	padding: 12px;
	resize: none;

	&::placeholder {
		color: #bfbfbf;
	}

	&:focus {
		border-color: #18405d;
		box-shadow: none;
	}
`;

export const ModalCancelButton = styled(AntButton)`
	min-width: 120px;
	height: 40px;
	border: 1px solid #d9d9d9;
	color: #000;
	font-weight: 500;

	&:hover {
		border-color: #18405d;
		color: #18405d;
	}
`;

export const ModalConfirmButton = styled(AntButton)`
	min-width: 120px;
	height: 40px;
	background: #18405d;
	border: none;
	color: #fff;
	font-weight: 500;

	&:hover {
		background: #1a4a6e;
		color: #fff;
	}

	&:disabled {
		background: #d9d9d9;
		color: #999;
	}
`;

// Back Button
export const BackButton = styled.span`
	font-size: 20px;
	cursor: pointer;
`;
